import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useContextMotifDetails } from '../contexts/motifDetailsContext'

const MotifDetailsQueryHandler = () => {
  const [searchParams] = useSearchParams()
  const motifId = searchParams.get('id')
  const { setTargetedMotif, setDetailsOpen, allMotifs } = useContextMotifDetails()

  useEffect(() => {
    if (!motifId || !allMotifs.length) return
    const motif = allMotifs.find(m => m.id === Number(motifId))
    if (!motif) return

    setTargetedMotif(motif.id)
    setDetailsOpen(true)
  }, [allMotifs])

  return null
}

export default MotifDetailsQueryHandler
